import $axios from "../../api/axios";

function getLstApi({ params, callback }) {
  $axios
    .get(`/api/orders/reserve/0/9999999999/${params.page}/${params.pageSize}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function makeReservation({ params, callback }) {
  $axios
    .post(`/api/create-checkout-session`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getLstApi,
  makeReservation
};



// WEBPACK FOOTER //
// ./src/api/account/reserve.js